import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.service";
import { TOAST_SUCCESS } from "../../utils/common.service";

export const getTeamListApiCall = createAsyncThunk("teamsList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: teamsList } = await API.getTeamListApi(submitData);
        dispatch(setLoader(false))
        return teamsList;
    } catch (error) {
        throw error;
    }
});

export const editTeamDataApiCall = createAsyncThunk("editTeamData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: editTeamData, code, message } = await API.editTeamDetailsApi(submitData);
        if (code === '1') {
            TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editTeamData, code, message };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    teamsList: {
        data: [],
        error: null,
    },
    editTeamData: {
        data: null,
        code: '',
        message: '',
        error: null,
    }
};

const teamSlice = createSlice({
    name: "TEAM",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getTeamListApiCall.fulfilled, (state, action) => {
                state.teamsList.data = action.payload;
            })
            .addCase(getTeamListApiCall.rejected, (state, action) => {
                state.teamsList.error = action.error.message;
            })
            .addCase(editTeamDataApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editTeamData.data = data;
                state.editTeamData.message = message;
                state.editTeamData.code = code;
            })
            .addCase(editTeamDataApiCall.rejected, (state, action) => {
                state.editTeamData.error = action.error.message;
            });
    },
});

export default teamSlice.reducer;